import Environment from '@eatzy/common-reactjs/Environment';
import { sessionRequest, portalGeneration } from './PortalSession';
import { jsonHeaders } from './JsonHeaders';

export default class API {
  buildConfig = async ({ endpoint, body, params, method, customConfig }) => {
    const baseUrl = Environment.getEnv('API_URL');

    const url = new URL(baseUrl + endpoint);
    Object.keys(params || {}).forEach((key) => {
      url.searchParams.append(key, params?.[key]);
    });

    const config = {
      method,
      ...customConfig,
      headers: jsonHeaders(customConfig?.headers),
    };
    if (body) {
      config.body = JSON.stringify(body);
    }

    return [url, config];
  };

  improvedFetch = async (
    endpoint,
    { body, params, method, ...customConfig },
    attemptsLeft
  ) => {
    const generation = portalGeneration();
    const [url, config] = await this.buildConfig({
      endpoint,
      body,
      params,
      method,
      customConfig,
    });
    if (endpoint.startsWith('/deliveryops/') && generation !== portalGeneration()) {
      throw Object.assign(new Error('Session request cancelled'), { name: 'AbortError' });
    }

    const fetchRequest = () => endpoint.startsWith('/deliveryops/')
      ? sessionRequest((signal) => window.fetch(url, { ...config, signal }), config.signal)
      : window.fetch(url, config);
    return fetchRequest().catch(async (err) => {
      if (attemptsLeft > 0 && err.status === 403 &&
          endpoint !== '/account/authorize' &&
          !endpoint.startsWith('/deliveryops/') &&
          !/\/tip-adjustments(?:\/|$)/.test(endpoint) &&
          !/^\/deliveryops\/(?:orders|drivers)\/history(?:\/|$)/.test(endpoint) &&
          !/\/territory-coverage\/?$/.test(endpoint)) {
        return await this.improvedFetch(
          endpoint,
          { body, params, method, ...customConfig },
          attemptsLeft - 1
        );
      }
      return Promise.reject(err);
    });
  };

  get = async (endpoint, params, options = {}) =>
    this.improvedFetch(endpoint, { method: 'GET', params, ...options }, 1);

  post = async (endpoint, body, options = {}) =>
    this.improvedFetch(endpoint, { method: 'POST', body, ...options }, 1);

  patch = async (endpoint, body, options = {}) =>
    this.improvedFetch(endpoint, { method: 'PATCH', body, ...options }, 1);

  put = async (endpoint, body, options = {}) =>
    this.improvedFetch(endpoint, { method: 'PUT', body, ...options }, 1);
}

export const api = new API();
